import type {
  Assignment,
  AttendanceRecord,
  ClassSession,
  Course,
  LearningResource,
  SemesterResult,
} from '../types/academic'

export const currentSemester = 'First semester 2025/26'

export const courses: Course[] = [
  {
    id: 'crs-1',
    code: 'SYE 305',
    title: 'Control Systems Engineering',
    units: 3,
    lecturer: 'Dr. F. Adeyemi',
    semester: currentSemester,
    status: 'registered',
    capacity: 120,
    enrolled: 118,
    source: 'synced',
  },
  {
    id: 'crs-2',
    code: 'SYE 311',
    title: 'Operations Research II',
    units: 3,
    lecturer: 'Prof. N. Okonkwo',
    semester: currentSemester,
    status: 'registered',
    capacity: 120,
    enrolled: 104,
    source: 'synced',
  },
  {
    id: 'crs-3',
    code: 'CSC 321',
    title: 'Database Systems',
    units: 3,
    lecturer: 'Dr. B. Salami',
    semester: currentSemester,
    status: 'registered',
    capacity: 90,
    enrolled: 90,
    source: 'manual',
  },
  {
    id: 'crs-4',
    code: 'SYE 307',
    title: 'Engineering Statistics',
    units: 2,
    lecturer: 'Dr. K. Eze',
    semester: currentSemester,
    status: 'registered',
    capacity: 140,
    enrolled: 96,
    source: 'synced',
  },
  {
    id: 'crs-5',
    code: 'GST 301',
    title: 'Entrepreneurship Studies',
    units: 2,
    lecturer: 'Mrs. T. Bello',
    semester: currentSemester,
    status: 'available',
    capacity: 400,
    enrolled: 312,
    source: 'synced',
  },
  {
    id: 'crs-6',
    code: 'SYE 315',
    title: 'Simulation and Modelling',
    units: 3,
    lecturer: 'Dr. F. Adeyemi',
    semester: currentSemester,
    status: 'available',
    capacity: 80,
    enrolled: 61,
    source: 'synced',
  },
  {
    id: 'crs-7',
    code: 'CSC 335',
    title: 'Machine Learning Foundations',
    units: 3,
    lecturer: 'Dr. I. Ogundipe',
    semester: currentSemester,
    status: 'closed',
    capacity: 60,
    enrolled: 60,
    source: 'synced',
  },
]

export const timetable: ClassSession[] = [
  {
    id: 'cls-1',
    courseCode: 'SYE 305',
    title: 'Control Systems Engineering',
    day: 'Mon',
    start: '08:00',
    end: '10:00',
    venue: 'Engineering LT1',
    mode: 'In person',
  },
  {
    id: 'cls-2',
    courseCode: 'CSC 321',
    title: 'Database Systems',
    day: 'Mon',
    start: '12:00',
    end: '14:00',
    venue: 'CIT Lab 3',
    mode: 'In person',
  },
  {
    id: 'cls-3',
    courseCode: 'SYE 311',
    title: 'Operations Research II',
    day: 'Tue',
    start: '10:00',
    end: '12:00',
    venue: 'Engineering LT2',
    mode: 'In person',
  },
  {
    id: 'cls-4',
    courseCode: 'SYE 307',
    title: 'Engineering Statistics',
    day: 'Tue',
    start: '14:00',
    end: '16:00',
    venue: 'Online',
    mode: 'Online',
  },
  {
    id: 'cls-5',
    courseCode: 'SYE 305',
    title: 'Control Systems tutorial',
    day: 'Wed',
    start: '09:00',
    end: '10:00',
    venue: 'Engineering LT1',
    mode: 'In person',
  },
  {
    id: 'cls-6',
    courseCode: 'CSC 321',
    title: 'Database lab',
    day: 'Thu',
    start: '10:00',
    end: '13:00',
    venue: 'CIT Lab 1',
    mode: 'In person',
  },
  {
    id: 'cls-7',
    courseCode: 'SYE 311',
    title: 'Operations Research tutorial',
    day: 'Thu',
    start: '15:00',
    end: '16:00',
    venue: 'Engineering LT2',
    mode: 'In person',
  },
  {
    id: 'cls-8',
    courseCode: 'SYE 307',
    title: 'Statistics workshop',
    day: 'Fri',
    start: '11:00',
    end: '13:00',
    venue: 'Engineering Annex 4',
    mode: 'In person',
  },
]

export const assignments: Assignment[] = [
  {
    id: 'asg-1',
    courseCode: 'SYE 305',
    title: 'Problem set 4 — state space models',
    due: '2026-08-14',
    dueLabel: 'Tomorrow, 09:00',
    weight: 10,
    status: 'in_progress',
  },
  {
    id: 'asg-2',
    courseCode: 'CSC 321',
    title: 'Normalisation exercise',
    due: '2026-08-17',
    dueLabel: 'Mon 17 Aug, 23:59',
    weight: 15,
    status: 'not_started',
  },
  {
    id: 'asg-3',
    courseCode: 'SYE 311',
    title: 'Linear programming case study',
    due: '2026-08-21',
    dueLabel: 'Fri 21 Aug, 12:00',
    weight: 20,
    status: 'not_started',
  },
  {
    id: 'asg-4',
    courseCode: 'SYE 307',
    title: 'Hypothesis testing worksheet',
    due: '2026-08-07',
    dueLabel: 'Submitted 6 Aug',
    weight: 10,
    status: 'graded',
    score: 87,
  },
  {
    id: 'asg-5',
    courseCode: 'CSC 321',
    title: 'ER diagram draft',
    due: '2026-08-10',
    dueLabel: 'Submitted 9 Aug',
    weight: 5,
    status: 'submitted',
  },
  {
    id: 'asg-6',
    courseCode: 'SYE 305',
    title: 'Lab report 2',
    due: '2026-08-04',
    dueLabel: 'Overdue since 4 Aug',
    weight: 10,
    status: 'overdue',
  },
]

export const attendance: AttendanceRecord[] = [
  { courseCode: 'SYE 305', attended: 11, held: 12, requirement: 75 },
  { courseCode: 'SYE 311', attended: 9, held: 12, requirement: 75 },
  { courseCode: 'CSC 321', attended: 7, held: 11, requirement: 75 },
  { courseCode: 'SYE 307', attended: 10, held: 10, requirement: 75 },
]

export const results: SemesterResult[] = [
  {
    id: 'sem-2',
    label: 'Second semester 2024/25',
    gpa: 4.32,
    units: 16,
    grades: [
      { courseCode: 'SYE 208', title: 'Thermofluids', units: 3, score: 74, grade: 'A', points: 5 },
      { courseCode: 'SYE 212', title: 'Systems Analysis', units: 3, score: 68, grade: 'B', points: 4 },
      { courseCode: 'CSC 232', title: 'Data Structures', units: 3, score: 81, grade: 'A', points: 5 },
      { courseCode: 'MTH 241', title: 'Linear Algebra', units: 3, score: 63, grade: 'B', points: 4 },
      { courseCode: 'GST 212', title: 'Philosophy and Logic', units: 2, score: 71, grade: 'A', points: 5 },
      { courseCode: 'SYE 216', title: 'Engineering Drawing II', units: 2, score: 58, grade: 'C', points: 3 },
    ],
  },
  {
    id: 'sem-1',
    label: 'First semester 2024/25',
    gpa: 4.06,
    units: 17,
    grades: [
      { courseCode: 'SYE 201', title: 'Engineering Mathematics', units: 3, score: 66, grade: 'B', points: 4 },
      { courseCode: 'SYE 205', title: 'Circuit Theory', units: 3, score: 72, grade: 'A', points: 5 },
      { courseCode: 'CSC 231', title: 'Programming II', units: 3, score: 78, grade: 'A', points: 5 },
      { courseCode: 'MTH 231', title: 'Differential Equations', units: 3, score: 55, grade: 'C', points: 3 },
      { courseCode: 'STA 221', title: 'Probability', units: 3, score: 61, grade: 'B', points: 4 },
      { courseCode: 'GST 201', title: 'Nigerian Peoples and Culture', units: 2, score: 69, grade: 'B', points: 4 },
    ],
  },
]

export const cgpa = 4.19

export const resources: LearningResource[] = [
  {
    id: 'res-1',
    courseCode: 'SYE 305',
    title: 'Week 9 — state space representation',
    kind: 'Slides',
    addedBy: 'Dr. F. Adeyemi',
    addedAt: '2 days ago',
    size: '4.2 MB',
  },
  {
    id: 'res-2',
    courseCode: 'SYE 305',
    title: 'Tutorial recording — root locus',
    kind: 'Recording',
    addedBy: 'Dr. F. Adeyemi',
    addedAt: '4 days ago',
    size: '48 min',
  },
  {
    id: 'res-3',
    courseCode: 'CSC 321',
    title: 'Normalisation worked examples',
    kind: 'Notes',
    addedBy: 'Dr. B. Salami',
    addedAt: '1 week ago',
    size: '1.1 MB',
  },
  {
    id: 'res-4',
    courseCode: 'SYE 311',
    title: '2023/24 past paper with solutions',
    kind: 'Past paper',
    addedBy: 'Systems Engineering Students Association',
    addedAt: '2 weeks ago',
    size: '820 KB',
  },
  {
    id: 'res-5',
    courseCode: 'SYE 307',
    title: 'Recommended reading list',
    kind: 'Reading',
    addedBy: 'Dr. K. Eze',
    addedAt: '3 weeks ago',
    size: '6 items',
  },
]

export const examTimetable = [
  { courseCode: 'SYE 305', date: 'Mon 7 Dec', time: '09:00 — 12:00', venue: 'Main Hall A' },
  { courseCode: 'SYE 307', date: 'Wed 9 Dec', time: '09:00 — 11:00', venue: 'Main Hall B' },
  { courseCode: 'CSC 321', date: 'Fri 11 Dec', time: '13:00 — 16:00', venue: 'CIT Hall' },
  { courseCode: 'SYE 311', date: 'Tue 15 Dec', time: '09:00 — 12:00', venue: 'Main Hall A' },
]
